import { getStoredMemberHash } from '@omnia/ui'
import { getMemberHash } from '@vista-digital/occ-domain'

export class Gtm {
    public startInTicks: number
    public uniqueEventId?: number
    public element?: string

    public constructor(uniqueEventId?: number, element?: string) {
        this.startInTicks = new Date().getTime()
        this.uniqueEventId = uniqueEventId
        this.element = element
    }
}

export class DataLayer {
    public event: string
    public gtm: Gtm
    public customerId: string | null | undefined

    public constructor(event: string, uniqueEventId?: number, element?: string) {
        this.event = event
        this.gtm = new Gtm(uniqueEventId, element)
        this.customerId = getStoredMemberHash() || getMemberHash()
    }
}

export class CurzonDataLayer extends DataLayer {
    constructor(event: string, uniqueEventId?: number, element?: string) {
        super(event, uniqueEventId, element)
        delete this.customerId
    }
}

export class CurzonEcommerceItem {
    public constructor(model?: CurzonEcommerceItem) {
        if (model) {
            Object.assign(this, model)
            this.removeUndefinedProperties?.()
        }
    }
    public item_id?: string
    public item_name: string
    public item_category: string

    private removeUndefinedProperties?() {
        Object.keys(this).forEach(key => {
            if (this[key] === undefined) {
                delete this[key]
            }
        })
    }
}

class CurzonEcommercePricedItem extends CurzonEcommerceItem {
    public constructor(model?: CurzonEcommercePricedItem) {
        super(model)
        if (model) {
            this.price = Math.round((model?.price ?? 0) * 100) / 100
            this.quantity = model.quantity
        }
    }

    public price?: number
    public quantity?: number
}

export class MembershipItem extends CurzonEcommercePricedItem {
    public constructor(props: MembershipItem) {
        super(props)
        this.item_category = 'Membership'
    }
}

export class BundleItem extends CurzonEcommercePricedItem {
    public constructor(props: BundleItem) {
        super(props)
        this.item_category = 'Bundles'
    }
}

export class GiftItem extends CurzonEcommercePricedItem {
    public constructor(props: GiftItem) {
        super(props)
        this.item_category = 'Gift'
    }
}

export class FilmOrderItem extends CurzonEcommercePricedItem {
    public item_category: 'Film' | 'Item'
    public location_id: string

    public constructor(props: FilmOrderItem) {
        super(props)
        this.location_id = props.location_id
    }
}

export class CurzonEcommerce {
    public constructor(items: MembershipItem[] | CurzonEcommerceItem[] | FilmOrderItem[]) {
        this.items = items
    }

    public items: MembershipItem[] | CurzonEcommerceItem[] | FilmOrderItem[]
    public currency?: string
    public value?: number
    public transaction_id?: string
    public tax?: number
    public vista_transaction_id?: string
}

export class CurzonEcommerceDataLayer extends CurzonDataLayer {
    public ecommerce: CurzonEcommerce
    public membership_tier: string = 'None'

    public constructor(event: string, ecommerce: CurzonEcommerce, uniqueEventId?: number, element?: string) {
        super(event, uniqueEventId, element)
        this.ecommerce = ecommerce
    }
}

export class UserPropertiesUpdateDataLayer extends CurzonDataLayer {
    public user_properties: {
        membership_tier: string
    }

    public constructor(membershipTier: string, uniqueEventId?: number, element?: string) {
        super('user_properties_update', uniqueEventId, element)
        this.user_properties = {
            membership_tier: membershipTier,
        }
    }
}
